import api from "../api";

/**
 * Uploads banner data to the server.
 *
 * @param {Object} banners - The banners model to be uploaded.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const uploadBanners = async (banners) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/upload/banners`;

  try {
    const response = await api.post(endpoint, banners, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading banners:', error);
    throw error;
  }
}

export default uploadBanners;
